import AimdFlowQuestionsScreen from "../../components/AimdFlowQuestionsScreens"



const UserFlowQuestionnaire = () => {
    return (
        <div>
            <AimdFlowQuestionsScreen isUserFlow={true}></AimdFlowQuestionsScreen>
        </div>
    )
}

export default UserFlowQuestionnaire